require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// /Users/luca/dev/lucagarbin/milenkapuntel.it/~/core-js/modules/es6.array.species.js
// module id = 235
// module chunks = 0